import { connect } from "react-redux";
import ReportCardLog from "../components/Report/CardLog";

const ReportCardLogPage = ({ accessToken, currentLang }) => {
  return <ReportCardLog accessToken={accessToken} currentLang={currentLang} />;
};

function mapStateToProps({ auth, lang }) {
  return {
    auth,
    accessToken: auth.token.accessToken,
    currentLang: lang.currentLang,
  };
}

export default connect(mapStateToProps, null)(ReportCardLogPage);
